import colors from "../base/colors";
import pxToRem from "../functions/pxToRem";

const { grey } = colors;

const props = {
  cssScrollbarHeight: {
    scrollbarWidth: "thin",
    scrollbarColor: grey[300],

    "&::-webkit-scrollbar": {
      height: "6px",
      cursor: "pointer",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: pxToRem(10),
      backgroundColor: grey[300],
      cursor: "pointer",
    },
  },
  cssScrollbarWidth: {
    scrollbarWidth: "thin",
    scrollbarColor: grey[300],
    "&::-webkit-scrollbar": {
      cursor: "pointer",
      width: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      cursor: "pointer",
      borderRadius: pxToRem(10),
      backgroundColor: grey[300],
    },
  },
};

export default props;
